<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :spa="24">
				<el-card class="box-card">
					<h4 class="title">描述信息</h4>
					<el-form ref="form" :model="desDialog" label-width="120px" >
						<el-form-item label="详情">
							<editor v-model="desDialog.describe" :isClear="isClear" @change="change"></editor>
						</el-form-item>
						<el-form-item>
							<input type="button" @click="onSubmit('desDialog')" class="submit" value="提交">
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	import files from '../../../components/picFile.vue'
	import E from "wangeditor";
	import Editor from '../../../components/tinymce.vue'
	export default {
		components: {
			files,
			Editor
		},
		data() {
			return {
                desId:'',
                formId:'',
				desDialog: {
					describe:''
				},
				
				isClear: false,
				
				fileList: [],
				dialogVisible: false,
				ewmList:[],
				editorText: '', // 双向同步的变量
			}
		},
		created() {
            console.log(this.$route.query.rows)
            if(this.$route.query.iden == 'add'){
                this.formId = this.$route.query.rows
            }
			if (this.$route.query.iden == 'update') {
                this.desId = this.$route.query.rows.id
                this.desDialog.describe = this.$route.query.rows.describe
                this.formId = this.$route.query.rows.formId
			}
		},
		methods: {
            onSubmit(formName) {
				if(this.$route.query.iden == 'add'){
				           var obj = this;
				           obj.$http({
				           	method: 'post',
				           	url: '/api/v1/form/describe/add',
				           	data: {
				           		formId:this.formId,
								describe:this.desDialog.describe
				           	},
				           }).then((res) => {
				           	if (res.status == 200) {
                                   obj.$message.success('添加成功')
				           		// this.dialogVisible = false
				           		// this.getData()
				           		// this.addType = ''
								// this.desDialog.describe = ''
                                var id = this.formId
                                this.$router.push({
                                       path:'/home/desAdd',
                                       query:{
                                           iden:id
                                       }
                                   })
				           		
				           	} else {
				           		obj.$message.error(res.message)
				           	}
				           })
				        }
				else{
                    console.log(this.formId)
					this.onUpdate(formName)
				}
			},
			onUpdate(formName) {
				           var obj = this;
				           obj.$http({
				           	method: 'post',
				           	url: '/api/v1/form/describe/update',
				           	data: {
				           		id:this.desId,
								describe:this.desDialog.describe
				           	},
				           }).then((res) => {
				           	if (res.status == 200) {
				           		// this.dialogVisible = false
                                   obj.$message.success('修改成功')
                                   console.log(id)
                                   var id = this.formId
                                   this.$router.push({
                                       path:'/home/desAdd',
                                       query:{
                                           iden:id
                                       }
                                   })
				           		// this.getData()
				           		// this.addType = ''
								// this.desDialog.describe = ''
				           		
				           	} else {
				           		obj.$message.error(res.message)
				           	}
				           })
				          
				        },
            change(val) {
				console.log(val)
			},
			
		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 40px;
	}

	/deep/ .el-input__inner {
		height: 30px;
	}

	.picTip {

		height: 16px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.5;
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/form/desUpdate.vue